module.exports = __webpack_public_path__ + "img/gong.1c5de20b.jpg";